import React from "react";
import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { AboutSection } from "../components/AboutSection";
import { SpeakersSection } from "../components/SpeakersSection";
import { ExperienceSection } from "../components/ExperienceSection";
import { EventFormatSection } from "../components/EventFormatSection";
import { ImpactSection } from "../components/ImpactSection";
import { SponsorsSection } from "../components/SponsorsSection";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen" style={{ background: "#ffffff", fontFamily: "'Inter', Arial, sans-serif" }}>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <SpeakersSection />
        <ExperienceSection />
        <EventFormatSection />
        <ImpactSection />
        <SponsorsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
